var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"}),_c('Add',{on:{"click":function($event){return _vm.$router.push('/hospital-registration')}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }